import script from "./php.vue?vue&type=script&setup=true&lang=js"
export * from "./php.vue?vue&type=script&setup=true&lang=js"

import "./php.vue?vue&type=style&index=0&id=763cf8b5&lang=css"
import "./php.vue?vue&type=style&index=1&id=763cf8b5&scoped=true&lang=css"
import "@wangeditor/editor/dist/css/style.css?vue&type=style&index=2&lang=css"
import "./php.vue?vue&type=style&index=3&id=763cf8b5&lang=css"

import exportComponent from "D:\\APP\\vue3\\dh\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-763cf8b5"]])

export default __exports__